<template>
  <div>
    <div
      class="mb-20"
      v-if="
        p('Manage Module.Organisation.Buildings & Rooms.Add') ||
          p('Manage Module.Organisation.Buildings & Rooms.Edit')
      "
    >
      <div class="building-introduce" v-if="defaultBuilding">
        {{ $store.getters[`user/displayName`] }},
        {{ $t('text.we_have_created_a_default_facility') }}.<br />{{
          $t('text.if_you_want_edit_this_facility')
        }}
        <b
          @click="editDefaultBuilding"
          class="underline important-text pointer blue-font"
          >{{ $t('text.edit_facility') }}</b
        >, {{ $t('text.or_you_can') }}
        <b
          class="underline important-text pointer blue-font"
          @click="openAddBuildingDialog"
          >{{ $t('text.create_new') }}</b
        >.
      </div>
      <div class="mt-5" v-else>
        <el-button
          size="mini"
          class="common-btn mr-10"
          @click="openAddBuildingDialog"
          v-if="p('Manage Module.Organisation.Buildings & Rooms.Add')"
          >{{ $t('text.add_facility_and_floor_and_room') }}</el-button
        >
        <el-button
          size="mini"
          class="common-btn"
          @click="redirectToEditBuilding()"
          v-if="p('Manage Module.Organisation.Buildings & Rooms.Edit')"
          v-show="buildingOptions.length"
          >{{ $t('text.edit_facility_and_floor_and_room') }}</el-button
        >
      </div>
    </div>
    <el-form :model="form" ref="form" :rules="rules" label-position="top">
      <el-form-item
        :label="$t('text.facility_and_Floor_and_Room')"
        prop="RoomId"
      >
        <el-cascader
          class="wp-100"
          :placeholder="$t('text.facility_and_Floor_and_Room')"
          v-model="form.RoomId"
          :options="buildingOptionsForCascader"
          :props="{ expandTrigger: 'hover', emitPath: false }"
          popper-class="custom-cascader"
        >
        </el-cascader>
      </el-form-item>
    </el-form>
    <EditBuildingRoom
      ref="editBuildingRoom"
      :allBuildings="buildingOptions"
      @updateBuilding="getAllBuildings"
    />
    <AddBuilding
      ref="addBuilding"
      :allBuildings="buildingOptions"
      @updateBuilding="getAllBuildings"
    />
  </div>
</template>

<script>
import EditBuildingRoom from '@/components/manage/patients/editPatient/EditBuildingRoom.vue'
import AddBuilding from '@/components/manage/building/AddBuilding.vue'
import ApiService from '@/services/ApiService.js'
import swal from 'sweetalert'
export default {
  data() {
    return {
      loading: false,
      buildingOptions: [],
      buildingOptionsForCascader: [],
      form: {
        PatientId: '',
        RoomId: ''
      },
      rules: this.initRules(),
      defaultBuilding: null //The system will set a default building. If the Default building has not been modified, it can be modified
    }
  },
  components: {
    EditBuildingRoom,
    AddBuilding
  },
  mounted() {
    this.getAllBuildings()
  },
  watch: {
    buildingOptions: {
      handler() {
        this.buildingOptionsForCascader = JSON.parse(
          JSON.stringify(this.buildingOptions)
        )
        this.buildingOptionsForCascader.forEach(building => {
          building.children.unshift({
            value: 'Floor',
            label: this.$t('text.floor'),
            children: []
          })
          building.children.forEach(floor => {
            floor.children.unshift({
              value: 'Room',
              label: this.$t('text.room'),
              children: []
            })
          })
        })
        this.buildingOptionsForCascader.unshift({
          value: 'Building',
          label: this.$t('text.facility'),
          children: []
        })
      },
      deep: true
    }
  },
  methods: {
    initRules() {
      return {
        RoomId: [
          {
            required: true,
            message: this.$t('text.select_facility_floor_room'),
            trigger: 'change'
          }
        ]
      }
    },
    openAddBuildingDialog() {
      this.$refs.addBuilding.openDialog()
    },
    redirectToEditBuilding() {
      this.$router.push('/manage/buildings-rooms')
    },
    getAllBuildings() {
      this.loading = true
      ApiService.GetBuildings(this.$store.getters[`user/selecteOrganisationId`])
        .then(response => {
          this.loading = false
          if (response.data.success) {
            let allBuildings = response.data.data
            if (
              allBuildings.length === 1 &&
              allBuildings[0].BuildingName === 'Default'
            ) {
              this.defaultBuilding = allBuildings[0]
            } else {
              this.defaultBuilding = null
            }

            this.buildingOptions = allBuildings.map(building => {
              building.Floors = building.Floors.map(floor => {
                return {
                  ...floor,
                  value: floor.FloorId,
                  label: floor.FloorName,
                  children: floor.Rooms.map(room => {
                    return {
                      ...room,
                      value: room.RoomId,
                      label: room.RoomNumber
                    }
                  })
                }
              })
              return {
                ...building,
                value: building.BuildingId,
                label: building.BuildingName,
                children: building.Floors
              }
            })

            // when adding a new patient, building, floor and room should auto fill
            if (!this.form.PatientId && this.buildingOptions.length) {
              this.form.RoomId = this.buildingOptions[0].Floors[0].Rooms[0].RoomId
            }
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              title: this.$t('text.failed'),
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          this.loading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed')
          })
        })
    },
    editDefaultBuilding() {
      if (!this.defaultBuilding) return
      this.$refs.editBuildingRoom.openDialog()
      let buildingObj = [
        {
          id: this.defaultBuilding.BuildingId,
          label: this.defaultBuilding.BuildingName,
          type: 'building',
          children: this.defaultBuilding.Floors.map(floor => {
            return {
              id: floor.FloorId,
              label: floor.FloorName,
              type: 'floor',
              children: floor.Rooms.map(room => {
                return {
                  id: room.RoomId,
                  label: room.RoomNumber,
                  type: 'room'
                }
              })
            }
          })
        }
      ]
      this.$refs.editBuildingRoom.data = JSON.parse(JSON.stringify(buildingObj))
    }
  }
}
</script>
